<template>
    <div v-if="isLoadingForm"><i class="fas fa-circle-notch fa-spin"></i> Loading Locationform....

    </div>
    <div v-else class="pl-lg-4">
        <div v-if="isAdmin" class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Kunde
                    <span>*</span></label>
                <select v-model="location.customer"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <!-- <option value="" disabled selected>Kunde</option> -->
                    <option v-for="customer in customers" :key="customer.id" :value="customer['@id']">{{ customer.name
                        }}
                    </option>
                </select>
            </div>
            <div class="col-lg-1">
                <base-input alternative=""
                            required
                            label="Vertrags#"
                            placeholder="Vertrags#"
                            input-classes="form-control-alternative"
                            v-model="location.contractNumber"
                />
            </div>
            <div class="col-lg-1">
                <label class="form-control-label">
                    Abfrage-Limit?
                </label>
                <select v-model="location.isLimited"
                        :disabled="!isAdmin"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="" disabled selected>AbfrageLimit?</option>
                    <option :value="true">ja</option>
                    <option :value="false">nein</option>
                </select>
            </div>
            <div class="col-lg-1">
                <base-input alternative=""
                            type="number"
                            required
                            label="Abfragen/Monat"
                            placeholder="Limit"
                            input-classes="form-control-alternative"
                            v-model="location.limitCount"
                />
            </div>
            <div class="col-lg-1">
                <base-input alternative=""
                            type="number"
                            required
                            label="+ Abfragen"
                            placeholder="einmalig"
                            input-classes="form-control-alternative"
                            v-model="location.additionalLimitCount"
                />
            </div>
            <div class="col-lg-1">
                <label class="form-control-label">
                    Status
                </label>
                <select v-model="location.status"
                        :disabled="!isAdmin"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="" disabled selected>Standort aktiv?</option>
                    <option value="active">aktiv</option>
                    <option value="inactive">inaktiv</option>
                </select>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    Premium-Paket*</label><br>
                <switches v-model="location.isPremium"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches>
            </div>
        </div>
        <div v-if="isAdmin" class="row">
            <div class="col-lg-2">
                <label class="form-control-label">
                    Sperrdatenbank Aktiv*</label><br>
                <switches v-model="location.playerCheckAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    Aufgaben Aktiv*</label><br>
                <switches v-model="location.isTaskAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    Spielerschutz Aktiv
                    <span>*</span></label>
                <br>
                <switches v-model="location.isActivityAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    JuSchG Aktiv
                    <span>*</span></label>
                <br>
                <switches v-model="location.isInspectionTourAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    Bericht Aktiv
                    <span>*</span></label>
                <br>
                <switches v-model="location.isReportAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
            <div class="col-lg-2">
                <label class="form-control-label">
                    Protokoll Aktiv
                    <span>*</span></label>
                <br>
                <switches v-model="location.isProtocolAllowed"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            label="Interner Name"
                            placeholder="Name des Standorts"
                            input-classes="form-control-alternative"
                            v-model="location.name"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            label="Öffentlicher Name"
                            placeholder="Öffentlicher Name des Standorts"
                            input-classes="form-control-alternative"
                            v-model="location.externalName"
                />
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Art des Standortes
                    <span>*</span></label>
                <select v-model="location.art"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="Spielhalle">Spielhalle</option>
                    <option value="Wettannahme">Wettannahme</option>
                    <option value="Gaststätte">Gaststätte</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <base-input alternative=""
                            required
                            label="Straße und Hausnummer"
                            placeholder="Musterstraße 5"
                            input-classes="form-control-alternative"
                            v-model="location.street"
                />
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Sozialkonzept
                    </label>
                <select v-model="location.socialconcept"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option :value="null">keine Angabe</option>
                    <option v-for="sc in socialconcepts" :key="sc.id" :value="sc['@id']">{{ sc.name }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            label="Postleitzahl"
                            placeholder="12345"
                            input-classes="form-control-alternative"
                            v-model="location.postalcode"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            label="Stadt/Ort"
                            placeholder="Musterstadt"
                            input-classes="form-control-alternative"
                            v-model="location.city"
                />
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Bundesland
                    <span>*</span></label>
                <select v-model="location.state" @change="changeReportingType"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="" disabled selected>Bundesland</option>
                    <option v-for="state in states" :key="state.id" :value="state['@id']">{{ state.name }}</option>
                </select>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">Weitere Angaben zum Standort</h6>
        <div class="row">
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            min="18"
                            label="Min. Alter"
                            placeholder="Spieler müssen mindestens X Jahre alt sein"
                            input-classes="form-control-alternative"
                            v-model="location.minAge"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            label="Eingänge"
                            min="1"
                            placeholder="Anzahl der Eingänge zur Spielstätte oder Wettbüro"
                            input-classes="form-control-alternative"
                            v-model="location.entrances"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            min="1"
                            label="Konzessionen"
                            placeholder="Anzahl der Konzessionen"
                            input-classes="form-control-alternative"
                            v-model="location.concessions"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            min="0"
                            label="Geld-Gewinnspielgeräte"
                            placeholder="Anzahl der Spielgeräte mit Geld-Gewinnmöglichkeit"
                            input-classes="form-control-alternative"
                            v-model="location.gamblingmachines"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            min="0"
                            label="Quadratmeter"
                            placeholder="Quadratmeterzahl der Grundfläche"
                            input-classes="form-control-alternative"
                            v-model="location.squaremeters"
                />
            </div>
            <div class="col-lg-4">
                <base-input alternative=""
                            required
                            type="number"
                            min="0"
                            label="Unterhaltungsgeräte ohne Gewinnmöglichkeit"
                            placeholder="Anzahl der Unterhaltungsgeräte ohne Geld-Gewinnmöglichkeit"
                            input-classes="form-control-alternative"
                            v-model="location.entertainmentmachines"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Jugendschutzgesetz hängt aus</label><br>
                <switches v-model="location.isJuschgNotice"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Spielinformationen hängen aus</label><br>
                <switches v-model="location.isGameNotice"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Ist die Spielstätte TÜV zertifiziert?</label><br>
                <switches v-model="tuev"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
        </div>
        <fade-transition>
        <div v-if="tuev" class="row">
            <div  class="col-lg-6">
                <base-input alternative=""
                            required
                            label="TÜV Zertifkat"
                            placeholder="Ausstellende Organisation des Zertifkats"
                            input-classes="form-control-alternative"
                            v-model="location.tuevcertificate"
                />
            </div>
            <div v-if="tuev" class="col-lg-6">
                <base-input
                        label="TÜV Zertifikat gültig bis:"
                        placeholder="Bis wann ist das TÜV Zertifikat gültig?"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                ref="pickr"
                                :config="config"
                                :class="['form-control','form-control-alternative','datepicker']"
                                v-model="location.tuevEndsAt">
                    </flat-pickr>
                </base-input>
            </div>
        </div>
        </fade-transition>
        <hr v-if="location.isInspectionTourAllowed" class="my-4" />
        <h6 v-if="location.isInspectionTourAllowed" class="heading-small text-muted mb-4">Angaben zum Jugendschutzkontrollgang</h6>
        <div v-if="location.isInspectionTourAllowed" class="row">
            <div class="col-lg-6">
                <label class="form-control-label">
                    Kontrollgang Intervall
                    <span>* </span></label>
                <select v-model="location.tourintervall"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="14400">4 Stunden</option>
                    <option value="7200" selected>2 Stunden</option>
                    <option value="3600">1 Stunde</option>
                    <option value="1800">30 Minuten</option>
                    <option value="900">15 Minuten</option>
                </select>
            </div>
            <div class="col-lg-6">
                <label class="form-control-label">
                    Bei Start ausführen</label><br>
                <switches v-model="location.isInspectiontourReverse"
                          theme="bootstrap"
                          color="primary"
                          style="padding-left: 2rem;"
                          text-enabled="Ja"
                          text-disabled="Nein"></switches><br>
            </div>
        </div>
        <hr v-if="location.isActivityAllowed" class="my-4"  />
        <h6 v-if="location.isActivityAllowed" class="heading-small text-muted mb-4">Systemseitig generierte Spielerschutzmaßnahmen bei bestimmten Aktionen</h6>
        <div v-if="location.isActivityAllowed" class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei JuschG Kontrollgang (Vorfall)</label><br>
                <select v-model="location.juschgAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei neuem Sperreintrag</label><br>
                <select v-model="location.lockAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei Spielercheck (gesperrter Spieler)</label><br>
                <select v-model="location.requestAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="location.isActivityAllowed" class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei Spielercheck (Spieler unter 18)</label><br>
                <select v-model="location.minorAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei Spielercheck (Mindestalter nicht erreicht)</label><br>
                <select v-model="location.ageAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="location.isActivityAllowed" class="row">
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei Selbstsperre</label><br>
                <select v-model="location.selfLockAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
            <div class="col-lg-4">
                <label class="form-control-label">
                    Aktion bei Fremdsperre</label><br>
                <select v-model="location.foreignLockAction"
                        class="mb-1 custom-select form-control">
                    <option :value="null">keine Maßnahme</option>
                    <option v-for="action in actions" :key="action.id" :value="action['@id']">({{ action.id }}) {{ action.name }}
                    </option>
                </select>
            </div>
        </div>
        <hr v-if="location.playerCheckAllowed" class="my-4"  />
        <h6 v-if="location.playerCheckAllowed" class="heading-small text-muted mb-4">Angaben zum Sperrsystem</h6>
        <fade-transition>
            <p v-if="location.playerCheckAllowed">
                <label class="form-control-label">
                        Oasis verwenden?</label><br>
                    <switches v-model="oasis"
                              theme="bootstrap"
                              color="primary"
                              style="padding-left: 2rem;"
                              text-enabled="Ja, Oasis Kennung, Zertifikate und Passwörter liegen vor"
                              text-disabled="Nein, Oasis wird nicht benötigt"></switches><br>
                <small>Falls für diesen Standort Oasis Zugangsdaten vorliegen, können diese hier hinterlegt werden. Prüfen Sie, ob an diesem Standort Oasis als zentrale Sperrdatei gesetzlich vorgeschrieben ist.</small>
            </p>
        </fade-transition>
        <h6 class="heading-small text-muted mb-4" v-if="usesOasis" >Oasis Zugangsdaten</h6>
            <div v-if="usesOasis" :key="3+count" class="row">
                <div class="col-lg-3">
                    <base-input alternative=""
                                required
                                label="Betriebsstättenkennung"
                                placeholder="OASIS Kennung für diesen Standort"
                                input-classes="form-control-alternative"
                                v-model="location.oasisid"
                    />
                </div>
                <div class="col-lg-3">
                    <label class="form-control-label">
                        Zertifikat
                        <span>*</span></label>
                    <select v-model="location.oasiscert"
                            class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                        <!-- <option value="" disabled selected>Kunde</option> -->
                        <option v-for="cert in oasisCerts" :key="cert.id" :value="cert['@id']">{{ cert.name }} |
                            <span v-if="(typeof cert.privateCertValidDates !== 'undefined')">gültig bis: {{cert.privateCertValidDates.to | formatDateToDay }} </span>
                            <span v-else>ERROR</span>
                        </option>
                    </select>
                </div>
                <div v-show="(typeof location['@id'] !== 'undefined')" class="col-lg-3 text-right">
                    <label class="form-control-label">
                        Passwort ändern
                        </label><br>
                    <p style="float: left; width: 80%"><small>Falls sich das Oasis Passwort geändert hat, das neue Passwort bitte hier hinterlegt.</small></p>
                    <p style="float: left; width: 20%"><base-button type="primary" v-if="isOasisPwDisabled" v-on:click.prevent="changeOasisPw" icon="ni ni-atom"></base-button>
                    <base-button type="primary" v-else v-on:click.prevent="changeOasisPw" icon="ni ni-atom"></base-button></p>
                </div>
                <div class="col-lg-3">
                    <base-input v-bind:disabled="isOasisPwDisabled"
                                alternative=""
                                label="Betriebsstättenpasswort"
                                placeholder="Wie lautet das Passwort für diese Betriebsstätte"
                                input-classes="form-control-alternative"
                                v-on:blur="count++"
                                v-model="location.oasispw"
                    />
                </div>
            </div>
            <div v-if="usesOasis && typeof location !== 'undefined'" :key="4+count" class="row">
                <div class="col-lg-8">
                    <base-input alternative=""
                                required
                                label="OASIS WS URL"
                                placeholder="https://oasis.hessen.de/oasisws/"
                                input-classes="form-control-alternative"
                                v-model="location.oasisurl"
                    />
                </div>
                <div v-show="(typeof location['@id'] !== 'undefined')" class="col-lg-4">
                    <label class="form-control-label">
                        Verbindung prüfen</label><small> - Speichern Sie vorher Ihre Änderungen!</small><br>
                  <div class="row">
                  <div class="col"><base-button v-bind:disabled="isLoadingValidate" block type="secondary" v-on:click="getCheckOasisResponse"><span :key="count+'bcn1'" class="btn-inner--icon"><i v-if="isLoadingValidate" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-sound-wave"></i></span> Konzession</base-button></div>
                  <div class="col"><base-button v-bind:disabled="isLoadingValidate" block type="secondary" v-on:click="getOasisLocation"><span :key="count+'bcn1'" class="btn-inner--icon"><i v-if="isLoadingValidate" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-sound-wave"></i></span> Betriebsstätte</base-button></div>
                  </div>
                </div>
            </div>
        <div v-if="usesOasis" :key="'vo4'+count" class="row">
            <div class="col">
                <base-alert type="default" v-show="validateResponse.MELDUNG !== ''">
                    <b>Betriebsstättenkennung:</b> {{location.oasisid}}<br>
                    <b>Betriebsstättenpasswort:</b> {{(typeof location.oasispw !== 'undefined') ? location.oasispw : '****' }}<br><br>

                    <p v-if="validateResponse.SCHLUESSEL === '9999'"><strong>Ihr Zertifikat muss durch unsere Technik freigeschaltet werden. <a :href="'https://socialguard.app/support-short/?vname='+ $store.getters['authentication/firstname'] +'&nname='+ $store.getters['authentication/lastname'] +'&email='+ $store.getters['authentication/email'] +'&msg=Bitte%20Zertifikat%20für%20Standort%20'+ location.name +' (ID:%20' + location.id + ')%20freischalten.'" class="btn btn-secondary btn-sm" target="_blank">Freischaltung beantragen</a></strong></p>

                    <br><b>Meldung:</b> <span v-html="validateResponse.MELDUNG"></span></base-alert>
            </div>
        </div>
        <hr class="my-4" />
        <h6 class="heading-small text-muted mb-4">Weitere Einstellungen für den Standort</h6>
        <div class="row">
            <div class="col-lg-6">
                <label class="form-control-label">
                    Profilanlage durch Servicekräfte
                </label>
                <select v-model="location.profileCreationAllowed"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option v-bind:value="true" selected>ja</option>
                    <option v-bind:value="false">nein</option>
                </select>
            </div>
        </div>
        <hr v-if="location.isReportAllowed" class="my-4" />
        <h6 v-if="location.isReportAllowed" class="heading-small text-muted mb-4">Angaben zum Reporting</h6>
        <div v-if="location.isReportAllowed" class="row">
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Reporting Ziel: Name"
                            placeholder="An wen sollen die Berichte gesendet werden?"
                            input-classes="form-control-alternative"
                            v-model="location.reportingTargetName"
                />
            </div>
            <div class="col-lg-6">
                <base-input alternative=""
                            required
                            label="Reporting Ziel: E-Mail"
                            placeholder="Wie lautet die E-Mailadresse, an die die Berichte gesendet werden sollen?"
                            input-classes="form-control-alternative"
                            :valid="isEmailValid"
                            v-model="location.reportingTargetMail"
                />
            </div>
        </div>
        <div v-if="actualStateData !== null && location.isReportAllowed" class="row">
            <div class="col-lg-6">
                <label class="form-control-label">
                    Reportdatum automatisiert durch Socialguard bestimmen
                    <span>*</span></label>
                <select v-model="location.reporttype"
                        class="mb-3 custom-select form-control form-control-alternative form-control-lg">
                    <option value="" disabled selected></option>
                    <option value="master">automatisch</option>
                    <option value="custom">indiviuell</option>
                </select>
            </div>
            <div v-if="location.reporttype === 'custom'" class="col-lg-6">
                <base-input label="Reportdatum"
                            placeholder="Zu welchem Stichtag soll der Report erstellt und verschickt werden?"
                            :aria-disabled="location.reporttype !== 'custom'"
                >
                    <flat-pickr slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                :config="config"
                                class="form-control form-control-alternative datepicker"
                                v-model="location.upcomingReportAt">
                    </flat-pickr>
                </base-input>
            </div>
            <div v-else class="col-lg-6">
                <label class="form-control-label">
                    Reportdatum
                </label><br>
                {{location.upcomingReportAt | formatDateToDay}}
            </div>
        </div>
    </div>

</template>
<script>
    import FlatPickr from "vue-flatpickr-component"
    import "flatpickr/dist/flatpickr.css";
    import {German} from "flatpickr/dist/l10n/de.js";
    import Switches from "vue-switches";
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";


    export default {
        name: 'locationform',
        components: {FadeTransition, Switches, FlatPickr},
        props: {
            loadingProp: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                location: {
                    customer: null,
                    name: "",
                    externalName: "",
                    art: "Spielhalle",
                    isActivityAllowed: true,
                    isInspectionTourAllowed: true,
                    isReportAllowed: true,
                    isProtocolAllowed: true,
                    isTaskAllowed: false,
                    isPremium: false,
                    street: "",
                    postalcode: '',
                    city: "",
                    state: null,
                    entrances: 1,
                    concessions: 1,
                    gamblingmachines: 10,
                    entertainmentmachines: 0,
                    squaremeters: 144,
                    tuevcertificate: null,
                    tuevEndsAt: null,
                    tourintervall: 7200,
                    status: "",
                    socialconcept: null,
                    reporttype: 'master',
                    upcomingReportAt: null,
                    reportingTargetMail: '',
                    reportingTargetName: '',
                    oasisid: null,
                    minAge: 18,
                    oasisurl: null,
                    oasiscert: null,
                    oasispw: null,
                    isJuschgNotice: false,
                    isGameNotice: false,
                    deadlineAllowed: false,
                    profileCreationAllowed: true,
                    isInspectiontourReverse: false,
                    playerCheckAllowed: true,
                    juschgAction: null,
                    lockAction: null,
                    requestAction: null,
                    minorAction: null,
                    ageAction: null,
                    selfLockAction: null,
                    foreignLockAction: null,
                    contractNumber: '',
                    isLimited: false,
                    limitCount: 0,
                    additionalLimitCount: 0
                },
                oasisCerts: {},
                socialconcepts: {},
                count: 0,
                oasis: false,
                tuev: false,
                certsAreLoading: false,
                socialconceptsAreLoading: false,
                config: {
                    dateFormat: 'Y-m-d',
                    altFormat: 'd.m.Y',
                    altInput: true,
                    allowInput: true,
                    locale: German
                },
                validateResponse: {
                    ART: '',
                    SCHLUESSEL: '',
                    MELDUNG: ''
                },
                isLoadingValidate: false,
            }
        },
        created() {
            this.getSocialconcepts();
            if (!this.$store.getters['state/isReady']) this.$store.dispatch('state/getStateCollection');
            if (!this.$store.getters['customer/isReady']) {
                this.$store.dispatch('customer/getCustomerCollection').then(() => {
                        if (this.$store.getters['customer/showCustomerCollection'].length === 1) this.location.customer = this.$store.getters['customer/showCustomerCollection'][0]['@id'];
                    }
                );
            } else {
                if (this.$store.getters['customer/showCustomerCollection'].length === 1) this.location.customer = this.$store.getters['customer/showCustomerCollection'][0]['@id'];
            }

            if (!this.$store.getters['actions/isLoading'] && this.$store.getters['actions/isEmpty']) this.$store.dispatch('actions/getActionCollection');

        },
      watch: {
        customer() {
          if (this.location.customer !== null) {
            this.getOasisCerts();
          }
        },
      },
        computed: {
            customers() {
                return this.$store.getters['customer/showCustomerCollection'];
            },
          customer() {
              return this.location.customer
          },
            states() {
                return this.$store.getters['state/showStateCollection'];
            },
            actualStateData() {
                return (this.$store.getters['state/isReady']) ? this.$store.getters['state/showStateByIRI'](this.location.state) : null;
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            },
            isEmailValid(){
                return (this.location.reportingTargetMail === '') ? null : this.validEmail(this.location.reportingTargetMail);
            },
            isOasisPwDisabled() {
                // eslint-disable-next-line no-unused-vars
                let o = this.count;
                return typeof this.location.oasispw === 'undefined'
            },
            usesOasis() {
                return this.oasis;
            },
            isLoadingForm() {
                  return this.certsAreLoading || this.loadingProp || this.socialconceptsAreLoading || this.$store.getters['state/isLoading'] || this.$store.getters['customer/isLoading'] || this.$store.getters['actions/isLoading'];
            },
            actions(){
                return (!this.$store.getters['actions/isLoading'] && !this.$store.getters['actions/isEmpty']) ? Array.from(this.$store.getters['actions/showActionCollectionByConcept'](this.location.socialconcept)) : [{id: 0, name: ''}];
            },
        },
        methods: {
          getOasisLocation () {
            this.isLoadingValidate = true;
            this.count++;
            this.getOasisLocationData().then(response => {

              const meldungItem = response['MELDUNGSKATALOG-ITEM'] || response;

              this.validateResponse = {
                ART: meldungItem.ART,
                SCHLUESSEL: meldungItem.SCHLUESSEL,
                MELDUNG: meldungItem.MELDUNG + '<br><br>Kennung: ' + response.KENNUNG + ' <br>Name: ' + response['NAME-BS'] + ' <br>Anschrift: ' + response.ANSCHRIFT
              };

              this.isLoadingValidate = false;
              this.count++;
            }).catch(error => {
                  // eslint-disable-next-line no-console
                  console.log(error);
                  this.validateResponse.ART = 'E';
                  this.validateResponse.MELDUNG = error;
                  this.validateResponse.SCHLUESSEL = (this.validateResponse.MELDUNG.includes('client certificate not found')) ? '9999' : '8888';
                  this.isLoadingValidate = false;
                }

            )
          },
          getOasisLocationData() {
            return new Promise((resolve, reject) => {
              const header = this.authHeader();
              header['Content-Type'] = 'application/json';
              const requestOptions = {
                method: 'GET',
                headers: header,
              };

              let url = '/oasis/info/'+this.location.id;

              fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                  .then(this.handleResponse)
                  .then(response => { resolve(response);},
                      error => { reject(error); });
            });
          },
            getCheckOasisResponse () {
                this.isLoadingValidate = true;
                this.count++;
                this.checkOasis().then(response => {
                  const validUntilMessage = response['GUELTIG-BIS']
                      ? ` <br><br>Die Konzession ist gültig <br>von: ${response['GUELTIG-VON'].DATUM} <br>bis: ${response['GUELTIG-BIS'].DATUM} <br><br> Um Ausfälle zu vermeiden, senden Sie bitte 3 Monate vor Ablauf der Konzession, eine neue Konzession an das RP Darmstadt.`
                      : '';

                  const meldungItem = response['MELDUNGSKATALOG-ITEM'] || response;

                  this.validateResponse = {
                    ART: meldungItem.ART,
                    SCHLUESSEL: meldungItem.SCHLUESSEL,
                    MELDUNG: meldungItem.MELDUNG + validUntilMessage
                  };

                  this.isLoadingValidate = false;
                  this.count++;
                }).catch(error => {
                    // eslint-disable-next-line no-console
                    console.log(error);
                    this.validateResponse.ART = 'E';
                    this.validateResponse.MELDUNG = error;
                    this.validateResponse.SCHLUESSEL = (this.validateResponse.MELDUNG.includes('client certificate not found')) ? '9999' : '8888';
                    this.isLoadingValidate = false;
                    }

                )
            },
            checkOasis() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };

                    let url = '/oasis/validate/'+this.location.id;

                    fetch(process.env.VUE_APP_API_SERVER + url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => { resolve(response);},
                            error => { reject(error); });
                });
            },
            changeReportingType() {
                this.$nextTick(() => {
                    let loc = this.$store.getters['state/showStateByIRI'](this.location.state);
                    this.location.reporttype = loc.reportdaytype;
                    if (loc.reportdaytype === "custom") {
                        var d = new Date();
                        var year = d.getFullYear();
                        var month = d.getMonth();
                        var day = d.getDate();
                        var c = new Date(year + 1, month, day);
                        this.location.upcomingReportAt = c;
                    } else {
                        this.location.upcomingReportAt = loc.upcomingReportAt;
                    }
                });
            },
            changeOasisPw(){
                if(typeof this.location.oasispw === 'undefined'){
                    Object.assign(this.location,{oasispw:null});
                } else {
                    delete this.location.oasispw;
                }
                this.count++;
            },
            getOasisCerts() {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.certsAreLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs?pagination=false&customer=` + this.location.customer, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.oasisCerts = response['hydra:member'];
                                this.certsAreLoading = false;
                            },
                            error => {
                                this.certsAreLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            getSocialconcepts() {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.socialconceptsAreLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/socialconcepts?pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.socialconcepts = response['hydra:member'];
                                this.socialconceptsAreLoading = false;
                            },
                            error => {
                                this.socialconceptsAreLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            requestCertificateApproval() {


            }
        }
    }
</script>
